export enum Direction {"left", "right", "up", "down", null}
export enum DirectionHorizontal {"left", "right", null}
export enum AnimationState {"standing", "attacking", "walking", null}

export enum SkillNames
{
    "Orb",
    "Sword vortex",
    "Arrow",
    "Bird",
    "Dragon",
    "Fire",
    "Ice",
    "Poison",
    "Mobility",
    "Heart"
}